<template >

    <v-dialog
         transition="dialog-bottom-transition"
         max-width="100%"
         v-model="dialogshow"
         persistent>
         <v-card style="background-color: #000C17 !important">
             <v-card-actions class="justify-end">
                 <v-btn
                 text
                  @click="dialogshow = false"
                  class="white--text"> Close </v-btn>
              </v-card-actions>
              <v-card-text>
 
             <v-container  class="px-lg-10 monsterrat">
                 <v-layout row>
                 <v-flex lg5 xs12 class="text-left white--text mt-lg-2 mt-10 font18 font24">
                     {{studentName ? studentName : '[student’s name]'}} Level Test Report 
                   
                 </v-flex >
                 <v-flex lg1 xs12 class="mt-lg-0 mt-5 ml-lg-16 pl-lg-16">
                       <!-- <audio controls v-if="audioVal1" class="audio-xs-width" >
                         <source :src="audioVal1" type="audio/mp3">
                         </audio> -->
                             
                             <!-- <AudioTwo v-if="fileName" :url="fileName" playerid="audio-player" class="ml-lg-16"/> -->
                         <!-- <div class="ml-lg-16 pl-lg-16"> <div class="ml-lg-16">  <v-btn class="white--text class-audio-btn ml-lg-16"> 수업녹음파일 </v-btn> </div> </div> -->
                  </v-flex>
                 </v-layout>
 
                 <!-- one -->
 
                 <v-layout row justify-center :class="prev==2? 'w3-animate-left mt-10 pb-10 px-lg-0' : 'w3-animate-right mt-10 pb-10 px-lg-0'" v-show="next==1 ? true : false"  v-touch="{
              left: () => swipe('Left'),
              right: () => swipe('Right'),
                  }" >
 
                         <v-flex lg6 xs10 class="white--text px-lg-10 px-2">
                                 <span class="text-h6 monsterrat"> Score </span>
                                 <PieChartNew class="mt-5 ml-n16" :score-total="totalScore"/>
                               
                         </v-flex>
 
                         <v-flex lg6 xs12 class="white--text mt-lg-0 px-lg-16 mt-16">
                                 <span class="text-h6 monsterrat"> Level </span>
                                 <v-card color="rgb(16, 25, 43)" class="rounded-lg mt-lg-3 pb-4 elevation-0">
                                         <BarChartNew :score-total="MegaLevel()"/>
                                 </v-card>
                         </v-flex>
 
                 </v-layout>
 
                 <!-- two -->
 
                  <v-layout row justify-center :class="prev==3? 'w3-animate-left mt-10 pb-10 px-lg-0' : 'w3-animate-right mt-10 pb-10 px-lg-0'" v-show="next==2 ? true : windowwidth > 1200 ? true : false" v-touch="{
                     left: () => swipe('Left'),
                     right: () => swipe('Right'),
                  }">
 
                         <v-flex lg12 xs12 class="white--text px-lg-10 ">
                             <v-card class="rounded-lg px-lg-2 py-lg-10 mt-lg-3 elevation-0 card-height card-bg white--text" >
                                 <div class="font24 font15 font-weight-bold px-lg-16 px-5 py-lg-0 py-10" >
                                         Instructor’s Comments 
                                 </div>
                                 <div class="mt-lg-3 px-lg-16 px-5 font15 monsterrat" style="color:rgb(205, 205, 205) !important">
                                         {{teacherComment}} 
 
                                 </div>
 
 
                             </v-card>
 
 
                                
                         </v-flex>
 
                 </v-layout>
 
                 <!-- three -->
 
                  <v-layout row justify-center :class="prev==4? 'w3-animate-left mt-10 pb-10 px-lg-0' : 'w3-animate-right mt-10 pb-10 px-lg-0'" v-show="next==3 ? true :  windowwidth > 1200 ? true : false" v-touch="{
                 left: () => swipe('Left'),
                 right: () => swipe('Right'),
                  }">
 
                         <v-flex lg12 xs12 class="white--text px-lg-10 px-0">
                             <v-card class="rounded-lg px-lg-2 py-lg-16 mt-lg-3 elevation-0 card-height card-bg white--text px-2" >
                                
                                <v-layout row class="ml-lg-16 px-lg-10 px-6">
 
                                    <v-flex lg6 xs12 class="mt-lg-6 mt-10 ">
                                                    <div class="text-lg-h5 text-body-1 monsterrat">
                                                         Sentence Correction 
                                                    </div>
                                                    <div>
 
                                                         <p class="mt-lg-5 mt-2">
                                                         <v-icon medium color="red"> mdi-close </v-icon> <span style="color:rgb(205, 205, 205) !important" class="text-body-1 text-lg-h6 monsterrat"> {{mdiClose1}}   </span>
 
                                                         </p>
                                                         <p class="">
                                                         <v-icon medium color="green"> mdi-check </v-icon> <span style="color:rgb(139, 220, 255) !important"  class=" text-body-1 text-lg-h6 font-weight-medium monsterrat"> {{mdiCheck1}} </span>
 
                                                         </p>
 
                                                    </div>
                                                     <div class="mt-18">
 
                                                         <p class="mt-lg-16">
                                                         <v-icon medium color="red"> mdi-close </v-icon> <span style="color:rgb(205, 205, 205) !important" class="text-body-1 text-lg-h6 monsterrat"> {{mdiClose2}} </span>
 
                                                         </p>
                                                         <p class="">
                                                         <v-icon medium color="green"> mdi-check </v-icon> <span style="color:rgb(139, 220, 255) !important" class="text-body-1 text-lg-h6 font-weight-medium monsterrat"> {{mdiCheck2}}  </span>
 
                                                         </p>
                                                         
                                                    </div>
                                    </v-flex>
 
                                    <v-flex lg6 xs12 class="mt-lg-6 mt-2">
                                                   <div class="text-lg-h5 text-body-1 monsterrat">
                                                         Words to be Careful with
                                                    </div>
                                                    <div>
 
                                                        
                                                         <p :class="prev==4 ? 'mt-n2 w3-animate-left' : 'mt-3 w3-animate-right'">
                                                            
                                                             <v-flex>
                                                                 <!-- <audio controls v-if="audioVal1" class="audio-xs-width" >
                                                                     <source :src="audioVal1" type="audio/mp3">
                                                                 </audio> -->
                                                                 <AudioOne v-if="audioVal1"
                                                                 number-seq="1."
                                                                 :word-audio="wordOne"
                                                                 :url="audioVal1"
                                                                 :texttospeech="texttospeech1"
                                                                 :translated="trans1"
                                                                 playerid="audio-player"/>
                                                             </v-flex>
                                                             
                                                         </p>
 
                                                        
 
                                                         <div class="mt-17">
                                                        
                                                         <p :class="prev==4 ? 'mt-n2 w3-animate-left' : 'mt-n2 w3-animate-right'" >
                                                             
                                                             
 <!-- 
                                                                 <audio controls v-if="audioVal2" class="audio-xs-width">
                                                                     <source :src="audioVal2" type="audio/mp3">
                                                                 </audio> -->
 
                                                              <AudioOne v-if="audioVal2"
                                                                 number-seq="2."
                                                                 :word-audio="wordTwo"
                                                                 :url="audioVal1"
                                                                 :texttospeech="texttospeech2"
                                                                 :translated="trans2"
                                                                 playerid="audio-player"/>
                                                         </p>
                                                         </div>
 
                                                    </div>
                                    </v-flex>
 
 
                                </v-layout>
 
                             </v-card>
                         </v-flex>
 
                 </v-layout>
 
                 <!-- four -->
 
                  <v-layout row justify-center :class="prev==4? 'w3-animate-left mt-10 pb-10 px-lg-0' : 'w3-animate-right mt-10 pb-10 px-lg-0'" v-show="next==4 ? true :  windowwidth > 1200 ? true : false" v-touch="{
              left: () => swipe('Left'),
              right: () => swipe('Right'),
                  }">
 
                         <v-flex lg12 xs12 class="white--text px-lg-10 px-0">
                             <v-card class="rounded-lg px-lg-2 py-lg-16 mt-lg-3 elevation-0 card-height card-bg white--text" >
 
                                <div class="text-lg-h5 ml-lg-16 px-lg-10 text-body-1 px-5 py-5 monsterrat">
                                                         Level Analysis
                                 </div>
 
                                <v-layout row class="ml-lg-16 px-lg-10 mt-lg-5 px-7 mt-5">
 
                                    <v-flex lg6 xs12>
                                         <v-layout justify-space-around>
                                                 <v-flex lg6 xs6>
                                                       <v-list-item-content>
                                                         <span class="font-weight-medium text-subtitle-2 text-lg-body-1 monsterrat"> Total Score</span>
                                                       </v-list-item-content>
 
                                                 </v-flex>
                                                  <v-flex lg6 xs6 class=" mt-n3 ml-lg-8 ml-4">
                                                       <v-list-item-content>
                                                         <span> <span class="text-lg-h2 text-h3 font-weight-bold monsterrat"> {{totalScore}} </span> <span style="color:rgb(205, 205, 205) !important" class="text-body-1  font-weight-medium ml-n3 monsterrat"> / 500 </span> </span>
                                                       </v-list-item-content>
 
                                                 </v-flex>
                                       </v-layout>
                                       <v-layout justify-space-around class="px-16 px-lg-0">
                                                 <v-flex lg6>
                                                       <v-list-item-content>
                                                         <span class="text-lg-body-1 font-weight-bold monsterrat"> Skill</span>
                                                         <span class="text-lg-subtitle-2 mt-lg-3 mt-4 monsterrat"> Pronunciation </span>
                                                         <span class="text-lg-subtitle-2 mt-lg-3 mt-4 monsterrat" > Grammar </span>
                                                         <span class="text-lg-subtitle-2 mt-lg-3 mt-4 monsterrat"> Vocabulary </span>
                                                         <span class="text-lg-subtitle-2 mt-lg-3 mt-4 monsterrat"> Comprehension </span>
                                                         <span class="text-lg-subtitle-2 mt-lg-3 mt-4 monsterrat"> Fluency </span>
                                                       </v-list-item-content>
 
                                                 </v-flex>
                                                  <v-flex lg6 class="ml-lg-9 ml-14">
                                                       <v-list-item-content class="ml-lg-5 ml-7">
                                                         <span class="text-lg-body-1 font-weight-bold ml-lg-16"> Score</span>
                                                         <span class="text-lg-subtitle-2 mt-lg-3 mt-4  ml-lg-16 pl-lg-7 ml-6 monsterrat"> {{pronunVal * 10}} </span>
                                                         <span class="text-lg-subtitle-2 mt-lg-3 mt-4  ml-lg-16 pl-lg-7 ml-6 monsterrat"> {{gramVal * 10}} </span>
                                                         <span class="text-lg-subtitle-2 mt-lg-3 mt-4  ml-lg-16 pl-lg-7 ml-6 monsterrat"> {{vocaVal * 10}} </span>
                                                         <span class="text-lg-subtitle-2 mt-lg-3 mt-4  ml-lg-16 pl-lg-7 ml-6 monsterrat"> {{comVal * 10}}</span>
                                                         <span class="text-lg-subtitle-2 mt-lg-3 mt-4  ml-lg-16 pl-lg-7 ml-6 monsterrat"> {{fluVal * 10}} </span>
                                                       </v-list-item-content>
 
                                                 </v-flex>
                                       </v-layout>
                                    </v-flex>
 
                                    <v-flex lg6>
                                             <v-layout>
 
                                                 <v-flex lg12 xs12>
                                                       <v-list-item-content>
                                                         <span class="font-weight-medium text-subtitle-2 text-lg-body-1 monsterrat"> Score Comparison* </span>
                                                       </v-list-item-content>
 
                                                 </v-flex>
 
                                            </v-layout>
                                            <v-layout row class="ml-lg-n7">
 
                                                 <v-flex lg12 xs12 class="ml-lg-n1">
                                                       <v-list-item-content>
 
                                                         <v-flex lg6 xs5 class="ml-lg-n8 ml-n3">  
                                                             <v-img src="../../../../assets/images/LevelTest/reports/mega_blue.png" aspect-ratio="1" class="logo-mega" contain></v-img>
                                                             
                                                         
                                                         </v-flex>
                                                         <v-flex lg6 xs7 class="ml-lg-n1 ml-2">  
                                                           
                                                                 <v-card style="border:1px solid #9E9E9E;background: transparent; border-radius: 10px;" outlined class="white--text elevation-0 text-center px-1 px-lg-2 py-1 py-lg-4 ml-lg-4 mt-0 text-lg-body-2">
                                                                  
                                                                     <v-layout>
 
                                                                         <v-flex lg6 class="mt-lg-3 mt-2 text-lg-body-1 text-caption monsterrat">
                                                                             Level {{MegaLevel()}} 
                                                                         </v-flex>
 
                                                                         <v-flex lg6 class=" text-caption mt-lg-2 mt-2 monsterrat">
                                                                              <span  v-html="MegaLevelName(MegaLevel())">  </span>
                                                                         </v-flex>
 
                                                                     </v-layout>
                                                                 </v-card>
                                                         
                                                         </v-flex>
 
                                                       </v-list-item-content>
 
                                                 </v-flex>
 
                                                 <v-flex lg12 xs12 class="ml-lg-n5 ml-n1">
                                                       <v-list-item-content>
 
                                                         <v-flex lg6 xs5>  
                                                             <v-img src="../../../../assets/images/LevelTest/reports/toeic-logo.png" aspect-ratio="1" class="logo-mega3" contain></v-img>
                                                             <div class="text-center ml-lg-10 text-lg-body-1 text-body-2 ml-5">
                                                                 Speaking
                                                             </div>
                                                         
                                                         </v-flex>
                                                         <v-flex lg6 xs7 class="ml-lg-n5">  
                                                           
                                                                 <v-card style="border:1px solid #9E9E9E;background: transparent; border-radius: 10px; " outlined class="white--text elevation-0 text-center px-1 px-lg-2 py-3 py-lg-5 ml-lg-4 mt-0 text-lg-body-1 text-caption monsterrat">
    
                                                                              Level {{ToeicLevel(MegaLevel())}}
 
                                                                 </v-card>
                                                         
                                                         </v-flex>
 
                                                       </v-list-item-content>
 
                                                 </v-flex>
 
                                                 <v-flex lg12 xs12 class="ml-lg-n3 ml-n1">
                                                       <v-list-item-content>
 
                                                         <v-flex lg6 xs5>  
                                                             <v-img src="../../../../assets/images/LevelTest/reports/OPIc-logo.png" aspect-ratio="1" class="logo-mega2" contain></v-img>
                                                             
                                                         
                                                         </v-flex>
                                                         <v-flex lg6 xs7 class="ml-lg-n7">  
                                                           
                                                                 <v-card style="border:1px solid #9E9E9E;background: transparent; border-radius: 10px;" outlined class="monsterrat white--text elevation-0 text-center px-1 px-lg-2 py-3 py-lg-5 ml-lg-4  mt-0 text-lg-body-1 text-caption">
    
                                                                               {{OpicLevel(MegaLevel())}}
 
                                                                 </v-card>
                                                         
                                                         </v-flex>
 
                                                       </v-list-item-content>
 
                                                 </v-flex>
 
                                             </v-layout>
                                    </v-flex>
 
 
                                </v-layout>
 
                             </v-card>
                         </v-flex>
 
                 </v-layout>
 
                 <!-- five -->
 
                  <v-layout row justify-center class="w3-animate-right mt-10 pb-10 px-lg-0" v-show="next==5 ? true :  windowwidth > 1200 ? true : false" v-touch="{
              left: () => swipe('Left'),
              right: () => swipe('Right'),
                  }">
 
                         <v-flex lg12 xs12 class="white--text px-lg-10 px-0">
                             <v-card class="rounded-lg px-lg-2 py-lg-3 mt-lg-3 px-10 py-1 elevation-0  card-bg white--text" >
 
                                 <v-layout row justify-lg-space-between class="mt-5">
 
                                      <v-flex lg6 xs12 class="pr-10 px-lg-16">
                                                 <v-list-item-content>
 
                                                      
                                                         <span class="text-lg-body-2 font-weight-bold monsterrat"> Pronunciation </span> 
                                                         <!-- <span class="text-lg-subtitle-2 mt-lg-5">{{datax[0].no}}  </span> -->
                                                        <span class="text-lg-subtitle-2 mt-lg-2 mt-1 monsterrat" style="color:rgb(205, 205, 205) !important"> {{pronunciation[pronunVal-1]}} </span>
                                                 
                                                 </v-list-item-content>
 
                                           </v-flex>
 
                                           <v-flex lg6 xs12 class="px-lg-16 px-1">
 
                                                 <v-list-item-content class="mt-lg-2 mt-n4">
 
                                                      
                                                         <span class="text-lg-h5 font-weight-bold progress-color1 monsterrat"> {{pronunVal*10}}  </span> 
                                                         <!-- <span class="text-lg-subtitle-2 mt-lg-5">{{datax[0].no}}  </span> -->
                                                          <v-progress-linear :value="pronunVal*10" rounded color="rgb(0, 84, 122)" height="5"></v-progress-linear>
                                                 
                                                 </v-list-item-content>
 
                                      </v-flex>
                                       <v-flex lg6 class="pr-10 px-lg-16 mt-lg-0 mt-n3">
                                                 <v-list-item-content>
 
                                                      
                                                         <span class="text-lg-body-2 font-weight-bold monsterrat"> Grammar </span> 
                                                         <!-- <span class="text-lg-subtitle-2 mt-lg-5">{{datax[0].no}}  </span> -->
                                                        <span class="text-lg-subtitle-2 mt-lg-2 mt-1 monsterrat" style="color:rgb(205, 205, 205) !important"> {{grammar[gramVal-1]}} </span>
                                                 
                                                 </v-list-item-content>
 
                                           </v-flex>
 
                                           <v-flex lg6 class="px-lg-16 px-1">
 
                                                 <v-list-item-content class="mt-lg-2 mt-n4">
 
                                                      
                                                         <span class="text-lg-h5 font-weight-bold progress-color1 monsterrat"> {{gramVal*10}}  </span> 
                                                         <!-- <span class="text-lg-subtitle-2 mt-lg-5">{{datax[0].no}}  </span> -->
                                                          <v-progress-linear :value="gramVal*10" rounded color="rgb(0, 84, 122)" height="5"></v-progress-linear>
                                                 
                                                 </v-list-item-content>
 
                                      </v-flex>
                                       <v-flex lg6 class="pr-10 px-lg-16 mt-lg-0 mt-n3">
                                                 <v-list-item-content>
 
                                                      
                                                         <span class="text-lg-body-2 font-weight-bold monsterrat"> Vocabulary </span> 
                                                         <!-- <span class="text-lg-subtitle-2 mt-lg-5">{{datax[0].no}}  </span> -->
                                                        <span class="text-lg-subtitle-2 mt-lg-2 mt-1 monsterrat" style="color:rgb(205, 205, 205) !important"> {{vocabulary[vocaVal-1]}} </span>
                                                 
                                                 </v-list-item-content>
 
                                           </v-flex>
 
                                           <v-flex lg6 class="px-lg-16 px-1">
 
                                                 <v-list-item-content class="mt-lg-2 mt-n4">
 
                                                      
                                                         <span class="text-lg-h5 font-weight-bold progress-color1 monsterrat"> {{vocaVal*10}}  </span> 
                                                         <!-- <span class="text-lg-subtitle-2 mt-lg-5">{{datax[0].no}}  </span> -->
                                                          <v-progress-linear :value="vocaVal*10" rounded color="rgb(0, 84, 122)" height="5"></v-progress-linear>
                                                 
                                                 </v-list-item-content>
 
                                      </v-flex>
                                       <v-flex lg6 class="pr-10 px-lg-16 mt-lg-0 mt-n3">
                                                 <v-list-item-content>
 
                                                      
                                                         <span class="text-lg-body-2 font-weight-bold monsterrat"> Comprehension </span> 
                                                         <!-- <span class="text-lg-subtitle-2 mt-lg-5">{{datax[0].no}}  </span> -->
                                                        <span class="text-lg-subtitle-2 mt-lg-2 mt-1 monsterrat" style="color:rgb(205, 205, 205) !important"> {{comprehension[comVal-1]}} </span>
                                                 
                                                 </v-list-item-content>
 
                                           </v-flex>
 
                                           <v-flex lg6 class="px-lg-16 px-1">
 
                                                 <v-list-item-content class="mt-lg-2 mt-n4">
 
                                                      
                                                         <span class="text-lg-h5 font-weight-bold progress-color1 monsterrat"> {{comVal*10}}  </span> 
                                                         <!-- <span class="text-lg-subtitle-2 mt-lg-5">{{datax[0].no}}  </span> -->
                                                          <v-progress-linear :value="comVal*10" rounded color="rgb(0, 84, 122)" height="5"></v-progress-linear>
                                                 
                                                 </v-list-item-content>
 
                                      </v-flex>
                                       <v-flex lg6 class="pr-10 px-lg-16 mt-lg-0 mt-n3">
                                                 <v-list-item-content>
 
                                                      
                                                         <span class="text-lg-body-2 font-weight-bold monsterrat"> Fluency </span> 
                                                         <!-- <span class="text-lg-subtitle-2 mt-lg-5">{{datax[0].no}}  </span> -->
                                                        <span class="text-lg-subtitle-2 mt-lg-2 mt-1 monsterrat" style="color:rgb(205, 205, 205) !important"> {{fluency[fluVal-1]}} </span>
                                                 
                                                 </v-list-item-content>
 
                                           </v-flex>
 
                                           <v-flex lg6 class="px-lg-16 px-1">
 
                                                 <v-list-item-content class="mt-lg-2 mt-n4">
 
                                                      
                                                         <span class="text-lg-h5 font-weight-bold progress-color1 monsterrat"> {{fluVal*10}}  </span> 
                                                         <!-- <span class="text-lg-subtitle-2 mt-lg-5">{{datax[0].no}}  </span> -->
                                                          <v-progress-linear :value="fluVal*10"  rounded color="rgb(0, 84, 122)" height="5"></v-progress-linear>
                                                 
                                                 </v-list-item-content>
 
                                      </v-flex>
 
                                 </v-layout>
                                
                                         <v-flex lg12 xs12 class="text-center mt-lg-5 mt-5 pb-lg-5 pb-5">
                                         <v-btn outlined color="white" class="rounded-lg py-5 py-lg-5" small @click="feedBack()">
                                             Rate us 
                                         </v-btn>
                                         
                                         <v-btn outlined color="white" class="ml-5 rounded-lg py-5 py-lg-5 mt-lg-0 mt-4 ml-lg-2 ml-n1" small @click="enrollment()"> 
                                             Enroll now!
                                         </v-btn>
                                      </v-flex>
                                 
 
                             </v-card>
                         </v-flex>
                         
 
                 </v-layout>
 
                 <v-layout justify-center >
                                     
                                     <v-flex lg3 class="text-center mt-10" v-show=" windowwidth < 1200 ? true : false">
                                         <v-btn class="mx-2 elevation-0" fab dark style="height:15px; width:15px;" :color="next==1 ? 'rgb(3, 119, 188)' :'rgb(16, 25, 43)' " @click="nextslide('1')"> </v-btn>
                                         <v-btn class="mx-2 elevation-0" fab dark style="height:15px; width:15px;" :color="next==2 ? 'rgb(3, 119, 188)' :'rgb(16, 25, 43)' " @click="nextslide('2')"> </v-btn>
                                         <v-btn class="mx-2 elevation-0" fab dark style="height:15px; width:15px;" :color="next==3 ? 'rgb(3, 119, 188)' :'rgb(16, 25, 43)' " @click="nextslide('3')"> </v-btn>
                                         <v-btn class="mx-2 elevation-0" fab dark style="height:15px; width:15px;" :color="next==4 ? 'rgb(3, 119, 188)' :'rgb(16, 25, 43)' " @click="nextslide('4')"> </v-btn>
                                         <v-btn class="mx-2 elevation-0" fab dark style="height:15px; width:15px;" :color="next==5 ? 'rgb(3, 119, 188)' :'rgb(16, 25, 43)' " @click="nextslide('5')"> </v-btn>
                                     </v-flex>
 
                                 </v-layout>
             </v-container>
 
              </v-card-text>
         </v-card>
    </v-dialog>
        
 
 </template>
     
 <style scoped>
 html{
     margin:10px;
 }
 .monsterrat {
     font-family: 'Montserrat', serif !important;
 }
 
 #evaluation{
 background: #000C17 !important;
 padding:100px;
 }
 .card-bg{
     background-color:rgb(16,25,43);
     background-image: url('../../../../assets/images/RegularClass/mega-man-white2.png');
     background-repeat: no-repeat;
     background-position:95% 95%;
     background-size: 20%;
 }
 .font24{
     font-size:24px !important;
 }
 .card-height{
     height: 621px;
 }
 .progress-color1{
     color:#02A9F4 !important;
 }
 .logo-mega{
     max-height: 50px !important;
 }
 .logo-mega2{
     max-height:40px !important;
 }
 .logo-mega3{
     max-height:35px !important;
 }
 .mt-17{
     margin-top:100px
 }
 .mt-18{
     margin-top:150px
 }
 #journal-scroll::-webkit-scrollbar {
     width: 4px;
     cursor: pointer;
 
 }
 #journal-scroll::-webkit-scrollbar-track {
     background-color: rgba(229, 231, 235, var(--bg-opacity));
     cursor: pointer;
 }
 #journal-scroll::-webkit-scrollbar-thumb {
     cursor: pointer;
     background-color: #a0aec0;
     
 }
 .cd-center{
     position: absolute;
     top: 50%;
     left: 50%;
     transform: translate(-50%, -50%);
     width: 60px;
     height: 60px;
     border-radius: 50%;
     background-color: #f7fafc;
 }
 
 #progressButtonTimer,#progressButtonVolume{
     margin-top:-9px;
     right:-8px;
 }
 
 .class-audio-btn{
     background-color:rgb(16, 25, 43) !important;
 }
 
 
 
 
 @media screen and (max-width: 900px) {
 #evaluation{
 background: #000C17 !important;
 padding:20px;
 padding-left:20px;
 padding-right: 20px;
 }
 .mt-17{
     margin-top:0px
 }
 .mt-18{
     margin-top:0px
 }
 .font14{
     font-size:14px !important;
 }
 .font18{
     font-size:18px !important;
 }
 .font15{
     font-size:15px !important;
 }
 .card-bg{
     background-color:rgb(16,25,43);
     background-image: url('../../../../assets/images/RegularClass/mega-man-white2.png');
     background-repeat: no-repeat;
     background-position:100% 98%;
     background-size: 50%;
 }
 .card-height{
     height: 621px;
 }
 .card-height2{
     height: 751px;
 }
 .logo-mega{
     max-height: 30px !important;
 }
 .logo-mega2{
     max-height: 20px !important;
 }
 .logo-mega3{
     max-height: 20px !important;
 }
 .class-audio-btn{
 width:100% !important
 }
 }
 
 </style>
 <style scoped>
 
 @import '../../../../../src/assets/css/LevelTest/Forms/audioplayer.css';
 
 </style>
 <script>
 import PieChartNew from '@/components/LevelTest/Form/PieChartNew'
 import BarChartNew from '@/components/LevelTest/Form/BarChartNew'
 import AudioOne from "@/components/LevelTest/Report/audioOne"
 // import AudioTwo from '@/components/ClassRecordingAudio'
 import Vue from 'vue'
 import axios from 'axios'
 Vue.use(axios)
 export default {
     name: 'evaluationformnew',
     props:['studentName','audioOne','audioTwo','totalScore','pronunVal','gramVal','vocaVal','comVal','fluVal','mdiClose1','mdiCheck1','mdiClose2','mdiCheck2','wordOne','wordTwo','teacherComment'],
     components:{
      PieChartNew,
      BarChartNew,
      AudioOne,
     //  AudioTwo,
     },
     data:()=>{
         return{
             next:1,
             prev:2,
             StudentData:null,
             StudentName:null,
             audioVal1:null,
             audioVal2:null,
             dialogshow:false,
             windowwidth: screen.width,
             trans1:"",
             trans2:"",
             x: 'https://lex-audio.useremarkable.com/mp3/world_us_1.mp3',
             y:'https://lex-audio.useremarkable.com/mp3/beautiful_us_1.mp3',
             fileName:'',
             PrevStat:false,
             pronunciation:[
                 "Student’s pronunciation is not good."
                 ,"Student’s pronunciation is not good but student can pronounce some English words."
                 ,"Student’s pronunciation is not that bad. Student can pronounce some words."
                 ,"Student can pronounce common English words but finds it hard to speak uncommon words."
                 ,"Student can pronounce common English words and student is familiar with difficult words."
                 ,"Student can pronounce common and uncommon English words."
                 ,"Student can pronounce many English words and student can easily remember new words."
                 ,"Student can pronounce many English words and is familiar with difficult words."
                 ,"Student can pronounce any word in English."
             ],
             grammar:[
                'Student needs to know basic grammar.'
                 ,'Student knows a little about basic grammar.'
                 , 'Student knows about basic grammar but can’t apply it most of the time.'
                 ,'Student knows about basic grammar and can apply it sometimes.'
                 ,'Student mastered the basic grammar and applies it.'
                 ,'Student knows about basic and complex grammar.'
                 ,'Student knows about basic and complex grammar and student is applying it.'
                 ,'Student mastered grammar and student is always applying it in class.'
             ],
             vocabulary:[
                 'The student’s vocabulary still needs improvement. It sometimes takes him a while to find the right words.'
                 ,'There were still struggles to find the right words. It is necessary for the student to search for ways to improve vocabulary.'
                 ,'The student is somehow able to come up with good words but further practice is necessary. It is very important for the student to continue improving vocabulary to aid speaking in English spontaneously.'
                 ,'The student know easy words to use when communication in English. However, these easy and common words are not enough to aid student and to become more spontaneous.'
                 ,'The student is able to use correct words in aswering. However, there is still a need to boost word skills. Checking on the synonyms and antonyms of easy words will be of great help.'
                 ,'The student uses good vocabulary when talking in class, but the student sometimes forgets some vocabulary words. Constant practice and determination in studying English vocabulary can help the student so much.'
                 ,'The student can produce good sentences because of the student\'s good vocabulary. The student will continue to develop if the student will continue to boost learning vocabulary.'
                 ,'The student can use words according to context. Vocabulary words being used are advanced.'
             ],
             comprehension:[
                 'Student finds it hard to understand English.'
                 ,'Student finds it hard to understand English sometimes.'
                 ,'Student can understand the teacher but student finds it hard to understand difficult words.'
                 ,'Student can speak in English but student can only make very simple sentences with pauses.'
                 ,'Student can understand the teacher.'
                 ,'Student can understand the teacher regardless of the teacher’s pacing.'
                 ,'Student can understand the teacher even if the teacher talks really fast.'
             ],
             fluency:[
                'Student doesn’t speak English. Student is not fluent. Student can’t make complete sentences.'
                 ,'Student can speak little English and is always pausing. Student can’t make simple sentences.'
                 ,'Student can speak in English but finds it hard to explain to teacher. Student can construct phrases or clauses but not complete sentences'
                 ,'Student can understand the teacher but student can only understand common words.'
                 ,'Student can speak in English and can make simple to complex sentences with pauses.'
                 ,'Student can speak in English and can make complex and compound sentences but with minimal pauses.'
                 ,'Student can speak in English and can make complex and compound sentences without any pause.'
                 ,'Student can speak in English without any pause and can use uncommon words when talking in the class. Student can make complex sentences.'
                 ,'Student can speak English continuously and fluently. Student can make complex sentences without any difficulty.'
             ],
             texttospeech1:false,
             texttospeech2:false,
         }
     },
     mounted(){
 
           axios.get("https://phone.megatalking.com/origin/api/recordXML.php",
             {
             params:{
                 call_date: '20210118',
                 phone_number: '01094898406',
             }
             }
         )
         .then(rs => {
             let parser = new DOMParser();
                 let xml = parser.parseFromString(rs.data,"application/xml");
                 
                 this.fetchingXMLRecording(xml)
                 // console.log(xml)
         });
 
 
                         
           
 
         axios.get('https://phone.megatalking.com/origin/api/leveltest_evaluation.php?l_id='+this.$route.params.l_id+'&action=levelResult')
         // .then(response=>console.warn(response.data))
         .then((response)=>this.StudentData=response.data)
 
         axios.get('https://phone.megatalking.com/origin/api/leveltest_evaluation.php?l_id='+this.$route.params.l_id+'&action=studentInfo')
         // .then(response=>console.warn(response.data))
         .then((response)=>this.StudentName=response.data.name)
         // console.log(this.windowwidth)
 
        
         var audio=this.$refs.audioOne;
         audio.addEventListener(
           "loadedmetadata",
           function() {
             this.initSlider();
           }.bind(this)
         );
 
         audio.addEventListener(
           "canplay",
           function() {
             this.audioLoaded=true;
           }.bind(this)
         );
 
         this.$watch("isPlaying",function() {
 
           if(this.isPlaying) {
             var audio=this.$refs.audioOne;
             this.initSlider();
             if(!this.listenerActive) {
               this.listenerActive=true;
 
               audio.addEventListener("freqtimeupdate",this.playbackListener);
             }
           }
 
         });
         this.$watch("playbackTime",function() {
             // var audio=this.$refs.audioOne;
 
         var diff=Math.abs(this.playbackTime-this.$refs.audioOne.currentTime);
 
           if(diff>0.01) {
             this.$refs.audioOne.currentTime=this.playbackTime;
 
           }
 
         });
 
   
 
 
     },
     methods:{
         open(){
             this.dialogshow = true
             this.word1_audio(this.wordOne)
             this.word2_audio(this.wordTwo)
         },
         getpapago(vari,word){
              axios.get('https://phone.megatalking.com/origin/api/papago-api.php?word='+word)
                 //.then(response=>console.warn(response.data))
                 .then(response=>{this[vari] = response.data.message.result.translatedText
                     this.getDictionaryDef(response.data.message.result.translatedText)
                 
                 }).catch(error=>console.log('this is the error Data '+error))
 
         },
         fetchingXMLRecording(xml){
 
                 let dirname = xml.getElementsByTagName('dirname')
                 let fname = xml.getElementsByTagName('fname')
 
                 let dir = '';
                 let file ='';
                 // console.warn(record)
                 for(let i =0 ; i<dirname.length ; i++){
                    dir = dirname[i].firstChild.nodeValue;
                 }
 
                 for(let i =0 ; i<fname.length ; i++){
                    file = fname[i].firstChild.nodeValue;
                 }
 
                 this.fileName='http://121.78.147.57:8000/'+dir+''+file
 
                 // console.warn('http://121.78.147.57:8000/'+this.valueXMl+''+this.fileName)
 
 
         },
           getDefinition(word,variable,errorword,texttospeech){
                 axios
                     .get(
                     "https://api.dictionaryapi.dev/api/v2/entries/en_US/" + word
                     )
                     .then(
                     (response) =>{
                         
                         this[variable] =  response.data[0].meanings[0].definitions[0].definition
                         this[texttospeech] = true
                         
                         
                     }).catch(
                     (error) =>
                         error ? (this[errorword] = true) : (this[errorword] = false),
                     (this.e1 = 1)
                     );
             },
          word1_audio(val){
             axios.get('https://api.dictionaryapi.dev/api/v2/entries/en_US/'+val).then(response => {this.audioVal1=response.data[0].phonetics[0].audio
 
                     if(!this.audioVal1){
                             this.audioVal1 = response.data[0].phonetics[1].audio
                              if(!this.audioVal1){
                             this.getDefinition(val,"audioVal1","errorword1","texttospeech1") 
                             }
                         }
                     this.getpapago("trans1",val)
 
             }).catch(
               (error) =>
                 error ? this.getDefinition(val,"audioVal1","errorword1","texttospeech1") : ''
             );
                     },
          word2_audio(val){
             axios.get('https://api.dictionaryapi.dev/api/v2/entries/en_US/'+val).then(response => {this.audioVal2=response.data[0].phonetics[0].audio
 
                 if(!this.audioVal2){
                     this.audioVal2 = response.data[0].phonetics[1].audio
                      if(!this.audioVal2){
                         this.getDefinition(val,"audioVal2","errorword2","texttospeech2") 
                     }
                 }
                 this.getpapago("trans2",val)
             
             }).catch(
               (error) =>
                 error ? this.getDefinition(val,"audioVal2","errorword2","texttospeech2") : ''
             );
                 },
 
 
          MegaLevel: function(){
            
             if (this.totalScore <= 50) {
                 return "1"
             } else if (this.totalScore >= 51 && this.totalScore <= 100) {
                 return "2"
             } else if (this.totalScore >= 101 && this.totalScore <= 150) {
                 return "3"
             } else if (this.totalScore >= 151 && this.totalScore <= 200) {
                 return "4"
             } else if (this.totalScore >= 201 && this.totalScore <= 250) {
                 return  "5"
             } else if (this.totalScore >= 251 && this.totalScore <= 300) {
                 return  "6"
             } else if (this.totalScore >= 301 && this.totalScore <= 350) {
                 return "7"
             } else if (this.totalScore >= 351 && this.totalScore <= 400) {
                 return  "8"
             } else if (this.totalScore >= 401 && this.totalScore <= 450) {
                 return "9"
             } else {
                 return " Undefined Level"
             }
         },
 
 
 
 
         MegaLevelName(val){
            
             if (val == 1 ) {
                 return "Low Beginner"
             } else if (val == 2) {
                 return "Beginner"
             } else if (val == 3) {
                 return "High <br/> Beginner"
             } else if (val == 4) {
                 return "Low <br /> Intermediate"
             } else if (val == 5 ) {
                 return  "Intermediate"
             } else if (val == 6) {
                 return  "High <br /> Intermediate"
             } else if (val == 7) {
                 return "Pre <br /> Advanced"
             } else if (val == 8) {
                 return  "Advanced"
             } else if (val == 9) {
                 return "Post <br /> Advanced"
             } else {
                 return " Undefined Level"
             }
         },
         ToeicLevel(val){
            
             if (val == 1) {
                 return "2"
             } else if (val == 2) {
                 return "3"
             } else if (val == 3) {
                 return "4"
             } else if (val == 4) {
                 return "5"
             } else if (val == 5 || val == 6) {
                 return  "6"
             } else if (val == 7 || val == 8) {
                 return "7"
             } else if (val == 9) {
                 return  "8"
             } else {
                 return " Undefined Level"
             }
         },
         OpicLevel(val){
            
             if (val ==1 ) {
                 return "Novice Low"
             } else if (val == 2) {
                 return "Novice Mid"
             } else if (val == 3) {
                 return "Novice High"
             } else if (val == 4) {
                 return "Intermediate Low"
             } else if (val == 5) {
                 return  "Intermediate Mid 1"
             } else if (val == 6) {
                 return  "Intermediate Mid 2"
             } else if (val == 7) {
                 return "Intermediate Mid 3"
             } else if (val == 8) {
                 return  "Intermediate High"
             } else if (val == 9) {
                 return "Advanced Low"
             } else {
                 return " Undefined Level"
             }
         },
         nextslide(val) {
             if (val == 1) {
                 return this.prev = 2, this.next = 1
 
             } else if (val == 2) {
 
                     if (this.prev >= 3) {
                         return this.next = 2, this.prev = 3
                     } else if (this.prev <= 2) {
                         return this.next = 2, this.prev = 2
                     }
 
              } else if (val == 3) {
 
                     if (this.prev >= 4) {
                         return this.next = 3, this.prev = 4
                     } else if (this.prev <= 3) {
                         return this.next = 3, this.prev = 3
                     }
 
               } else if (val == 4) {
                 
                     if (this.prev >= 5) {
                         return this.next = 4, this.prev = 5
                     } else if (this.prev <= 4) {
                         return this.next = 4, this.prev = 4
                     }
 
             } else if (val == 5) {
                
 
                     return this.next = 5, this.prev = 5
 
                 } 
         },
         swipe(direction) {
 
             if (direction == 'Left') {
                if(this.next<5){
                    this.next++
                    this.prev++
                    // console.warn(this.prev)
                }
             } else if (direction == 'Right') {
                if(this.next>1){
                    this.next--
                    this.prev--
                    //  console.warn(this.prev)
                }
             }
         },
          feedBack(){
         this.$router.push({name:'feedbackformStudentNew',params:{l_id:this.$route.params.l_id}})
       },
       enrollment(){
         window.location.href="https://megatalking.co.kr/enrollment"
       },
 
     }
 }
 </script>
 
 